import GenericAPI, { CONTENT_TYPE } from "../GenericApi";
class SupplierProductApi extends GenericAPI {

    PRODUCT_DETAILS_ENDPOINT="/api/productDetail"

    async getProductDetails(businessId) {
        const payload =  {
            businessId
        }
        return this.get(this.PRODUCT_DETAILS_ENDPOINT, payload, true);
    }

    async addProduct(data) {
        return this.post(this.PRODUCT_DETAILS_ENDPOINT, data, CONTENT_TYPE.MULTIPART, true);
    }

    async updateProduct(data) {
        return this.put(this.PRODUCT_DETAILS_ENDPOINT, data, CONTENT_TYPE.MULTIPART, true);
    }
    async deleteProduct(productId) {
        const payload =  {
            productId
        }
        return this.delete(this.PRODUCT_DETAILS_ENDPOINT, payload, true);
    }
}

export default new SupplierProductApi();
